const snakeToCamelCase = str => {
	return str.replace(/([-_][a-z])/g, group =>
		group
			.toUpperCase()
			.replace("-", "")
			.replace("_", "")
	);
};

const snakeCaseObjectKeysToCamelCase = obj => {
	const newObj = {};

	Object.keys(obj).forEach(key => {
		newObj[snakeToCamelCase(key)] = obj[key];
	});

	return newObj;
};

const firstLetterToLowerCase = str => {
	return str[0].toLowerCase() + str.substring(1);
};

const withoutDuplicates = arr => {
	return [...new Set(arr)];
}

const formatDate = date => {
	return new Date(date).toLocaleString().substr(0, 17);
}

const debounce = (func, wait, immediate) => {
	var timeout;
	return function () {
		var context = this, args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

const lastOf = arr => arr[arr.length - 1];

// const getId = (() => {
// 	let id = 0;

// 	return id => {
// 		return ++id;
// 	};
// })();

const deepClone = obj => JSON.parse(JSON.stringify(obj));


const preloadImg = (fileName) => {
	if (Array.isArray(fileName)) {
		fileName.forEach(fileName => {
			const img = new Image();
			img.src = fileName;
		});
	} else {
		let img = new Image();
		img.src = fileName;
	}
}

class Flag {
	constructor() {
		this._flags = {};
	}

	create(name) {
		this._flags[name] = true;
		setTimeout(() => {
			delete this._flags[name];
		});
	}

	test(name) {
		return this._flags[name] || false;
	}
}


function sortInKey(arr, propKey) {
	return arr.sort((a, b) => {
		if (a[propKey] < b[propKey]) return -1;
		return a[propKey] > b[propKey] ? 1 : 0;
	});
}

function justOneOfSame(arr, key) {
	const alreadyInKeys = {};

	return arr.reduce((result, item) => {
		const prop = item[key];
		if (!(prop in alreadyInKeys)) {
			result.push(item);
			alreadyInKeys[prop] = 1;
		}
		return result;
	}, []);
}

export {
	snakeToCamelCase,
	snakeCaseObjectKeysToCamelCase,
	firstLetterToLowerCase,
	Flag,
	withoutDuplicates,
	lastOf,
	deepClone,
	preloadImg,
	debounce,
	sortInKey,
	justOneOfSame,
	formatDate
};
